import * as chrono from "chrono-node";
import { categorizeInformer } from "./categorizeInformer";
import { cleanString } from "../../../../utilities/cleanString";
export function parseInformer(informerHTML) {
    const results = {};
    results.html = informerHTML;
    if (informerHTML) {
        // removing empty children through mutation
        [...informerHTML.children].forEach((child) => {
            if (!child.textContent.trim()) {
                child.remove();
            }
        });
        // combining direct sibling lists into one list through mutation
        // TODO: Is this working? We append it to the list, and then remove the list?
        [...informerHTML.querySelectorAll("ul+ul")].forEach((list) => {
            [...list.children].forEach((listItem) => {
                list.previousElementSibling.append(listItem);
            });
            list.remove(); // really, whats the point of this one?
        });
        const lists = informerHTML.querySelectorAll("ul");
        results.reference = chrono.parseDate(informerHTML.querySelector("h3").textContent);
        results.sections = [];
        results.all = [];
        for (let i = 0, l = lists.length; i < l; i++) {
            const list = lists[i];
            const children = list.children;
            const section = {
                title: list.previousElementSibling.textContent.trim(),
                items: [],
            };
            for (let ci = 0, cl = children.length; ci < cl; ci++) {
                const item = children[ci];
                if (!item) {
                    continue;
                }
                let text;
                if (item.children.length === 1) {
                    const content = cleanString(item.textContent);
                    results.all.push(content);
                    if (content.toLowerCase().indexOf("expectant") > -1) {
                        const expectant = content.split(":");
                        results.expectant = {
                            title: cleanString(expectant[0]),
                            items: expectant[1]
                                .replace(/ ?(,? and|,|\.) ?/g, "|||")
                                .split("|||")
                                .map((d) => d.trim())
                                .filter((d) => d),
                        };
                        results.sections.push(results.expectant);
                    }
                    else {
                        text = content;
                    }
                }
                /*else {
                    // include multiple line items
                    text = [...item.children].map(row => {
                        return cleanString(row.textContent);
                    });

                    results.all.push(text);
                }*/
                if (text) {
                    section.items.push(text);
                }
            }
            results.sections.push(section);
            categorizeInformer(section, results);
        }
    }
    return results;
}
